/* eslint-disable */
import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { X, CheckCircle } from 'lucide-react';
import { C, ChecklistRow } from './teamUtils';

// ── Checklist templates ───────────────────────────────────────────────
const CHECKLIST_TEMPLATES = {
  barista: [
    { area:'Orientation', items:[
      { id:'o1', timeline:'Day 1',  description:'Training manual' },
      { id:'o2', timeline:'Day 1',  description:'House rules' },
      { id:'o3', timeline:'Day 1',  description:'Fire safety' },
      { id:'o4', timeline:'Day 1',  description:'Run sheet' },
      { id:'o5', timeline:'Day 1',  description:'Eitje' },
      { id:'o6', timeline:'Day 1',  description:'Team overview & roles' },
    ]},
    { area:'Checklists', items:[
      { id:'c1', timeline:'Week 1', description:'Opening' },
      { id:'c2', timeline:'Week 1', description:'Mid-shift' },
      { id:'c3', timeline:'Week 1', description:'Closing' },
      { id:'c4', timeline:'Week 2', description:'Weekly cleaning' },
    ]},
    { area:'POS Systems', items:[
      { id:'p1', timeline:'Week 1', description:'Tebi' },
      { id:'p2', timeline:'Week 2', description:'Kitchen screen' },
      { id:'p3', timeline:'Week 1', description:'Payments' },
    ]},
    { area:'Coffee Machine / Grinder', items:[
      { id:'m1', timeline:'Day 1',  description:'Dialling in' },
      { id:'m2', timeline:'Day 1',  description:'Setting up the bar' },
      { id:'m3', timeline:'Day 1',  description:'Cleaning the grinder' },
      { id:'m4', timeline:'Day 1',  description:'Cleaning coffee machine' },
    ]},
    { area:'Drinks', items:[
      { id:'d1', timeline:'Week 1', description:'Coffees' },
      { id:'d2', timeline:'Week 1', description:'Soft drinks' },
      { id:'d3', timeline:'Week 1', description:'Beers' },
      { id:'d4', timeline:'Week 2', description:'Wines' },
      { id:'d5', timeline:'Week 2', description:'Cocktails' },
    ]},
    { area:'Service', items:[
      { id:'s1', timeline:'Week 3', description:'Carrying a tray' },
      { id:'s2', timeline:'Week 3', description:'Carrying 3 plates' },
      { id:'s3', timeline:'Week 2', description:'Sequence of service' },
      { id:'s4', timeline:'Week 4', description:'Upselling' },
      { id:'s5', timeline:'Week 1', description:'Presentation standards' },
    ]},
    { area:'Food', items:[
      { id:'f1', timeline:'Week 2', description:'Brunch' },
      { id:'f2', timeline:'Week 3', description:'Dinner' },
      { id:'f3', timeline:'Week 3', description:'Allergens' },
    ]},
    { area:'Bar Prep', items:[
      { id:'b1', timeline:'Week 4', description:'JOD & COG cocktail juices' },
      { id:'b2', timeline:'Week 4', description:'Lemon & lime super juice' },
      { id:'b3', timeline:'Week 4', description:'Dehydrated fruit' },
      { id:'b4', timeline:'Week 4', description:'Cocktail batches' },
      { id:'b5', timeline:'Week 4', description:'Infusions — mary mix, stroop vodka, chilli tequila' },
    ]},
  ],
  server: [
    { area:'Orientation', items:[
      { id:'o1', timeline:'Day 1',  description:'Training manual' },
      { id:'o2', timeline:'Day 1',  description:'House rules' },
      { id:'o3', timeline:'Day 1',  description:'Fire safety' },
      { id:'o4', timeline:'Day 1',  description:'Run sheet' },
      { id:'o5', timeline:'Day 1',  description:'Eitje' },
      { id:'o6', timeline:'Day 1',  description:'WhatsApp' },
      { id:'o7', timeline:'Day 1',  description:'Team overview & roles' },
    ]},
    { area:'Checklists', items:[
      { id:'c1', timeline:'Week 1', description:'Opening' },
      { id:'c2', timeline:'Week 1', description:'Mid-shift' },
      { id:'c3', timeline:'Week 1', description:'Closing' },
      { id:'c4', timeline:'Week 3', description:'Weekly cleaning' },
    ]},
    { area:'POS Systems', items:[
      { id:'p1', timeline:'Week 1', description:'Tebi' },
      { id:'p2', timeline:'Week 1', description:'Kitchen screen' },
      { id:'p3', timeline:'Week 1', description:'Payments' },
    ]},
    { area:'Service', items:[
      { id:'s1', timeline:'Day 1',  description:'Carrying a tray' },
      { id:'s2', timeline:'Day 1',  description:'Carrying 3 plates' },
      { id:'s3', timeline:'Week 1', description:'Sequence of service' },
      { id:'s4', timeline:'Week 2', description:'Upselling' },
      { id:'s5', timeline:'Week 1', description:'Presentation standards' },
      { id:'s6', timeline:'Week 3', description:'Complaints procedures' },
    ]},
    { area:'Drinks', items:[
      { id:'d1', timeline:'Week 1', description:'Coffees / teas' },
      { id:'d2', timeline:'Week 1', description:'Soft drinks' },
      { id:'d3', timeline:'Week 1', description:'Beers' },
      { id:'d4', timeline:'Week 2', description:'Wines' },
      { id:'d5', timeline:'Week 2', description:'Cocktails' },
    ]},
    { area:'Food', items:[
      { id:'f1', timeline:'Week 1', description:'Brunch' },
      { id:'f2', timeline:'Week 2', description:'Dinner' },
      { id:'f3', timeline:'Week 3', description:'Allergens' },
    ]},
  ],
  manager: [
    { area:'General Service', items:[
      { id:'mg1', description:'Welcoming guests' },
      { id:'mg2', description:'Run sheet' },
      { id:'mg3', description:'Kitchen comms' },
      { id:'mg4', description:'Breaks' },
      { id:'mg5', description:'Running shifts' },
      { id:'mg6', description:'Cash up' },
    ]},
    { area:'The Lists', items:[
      { id:'ml1', description:'Opening checklist' },
      { id:'ml2', description:'Mid-shift checklist' },
      { id:'ml3', description:'Closing checklist' },
      { id:'ml4', description:'Weekly cleaning' },
    ]},
    { area:'Orders', items:[
      { id:'mo1',  description:'AGF & JK' },
      { id:'mo2',  description:'Hanos' },
      { id:'mo3',  description:'Sligro' },
      { id:'mo4',  description:'Friedhats' },
      { id:'mo5',  description:'Rightspirits' },
      { id:'mo6',  description:'Daxivin' },
      { id:'mo7',  description:'Chabrol' },
      { id:'mo8',  description:'Wine Stories' },
      { id:'mo9',  description:'Benelux' },
      { id:'mo10', description:'Matcha' },
      { id:'mo11', description:'Fiveways' },
      { id:'mo12', description:'Transfers' },
    ]},
    { area:'Admin', items:[
      { id:'ma1', description:'Eitje' },
      { id:'ma2', description:'Approving hours' },
      { id:'ma3', description:'Reservations' },
      { id:'ma4', description:'Emails' },
      { id:'ma5', description:'Scheduling' },
    ]},
    { area:'Bar', items:[
      { id:'mb1', description:'Coffee' },
      { id:'mb2', description:'Cocktails' },
      { id:'mb3', description:'Wines' },
      { id:'mb4', description:'Bar prep' },
    ]},
  ],
};

// ── Type config ───────────────────────────────────────────────────────
const TYPE_CONFIG = {
  barista: { label: 'Barista',         icon: '☕', color: C.orange,  hasTimeline: true  },
  server:  { label: 'FOH Server',      icon: '🍽️', color: C.skyText, hasTimeline: true  },
  manager: { label: 'Manager',         icon: '📋', color: C.purple,  hasTimeline: false },
};

export default function OnboardingChecklistModal({ member, currentUser, onClose }) {
  const canEdit = ['admin','manager','supervisor'].includes(currentUser?.role);
  const [checklist, setChecklist] = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [starting,  setStarting]  = useState(false);
  const [pickType,  setPickType]  = useState(false);
  const [saving,    setSaving]    = useState({});
  const [viewMode,  setViewMode]  = useState('category');

  useEffect(() => {
    async function load() {
      const { data } = await supabase
        .from('onboarding_checklists')
        .select('*')
        .eq('team_member_id', member.id)
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();
      setChecklist(data || null);
      setLoading(false);
    }
    load();
  }, [member.id]);

  async function startChecklist(type) {
    setStarting(true);
    const template = CHECKLIST_TEMPLATES[type];
    const hasTimeline = TYPE_CONFIG[type]?.hasTimeline;
    const items = template.flatMap(section =>
      section.items.map(item => ({
        ...item,
        area:    section.area,
        done:    false,
        manager: null,
        date:    null,
        notes:   '',
        // manager checklist has no timeline — set placeholder so ChecklistRow doesn't break
        timeline: hasTimeline ? (item.timeline || '') : null,
      }))
    );
    const { data, error } = await supabase
      .from('onboarding_checklists')
      .insert({ team_member_id: member.id, type, created_by: currentUser?.name || 'Manager', items })
      .select()
      .single();
    if (!error && data) setChecklist(data);
    setStarting(false);
    setPickType(false);
  }

  async function toggleItem(itemId) {
    if (!canEdit || !checklist) return;
    setSaving(p => ({ ...p, [itemId]: true }));
    const updated = checklist.items.map(i => {
      if (i.id !== itemId) return i;
      const nowDone = !i.done;
      return {
        ...i,
        done:    nowDone,
        manager: nowDone ? (currentUser?.name || 'Manager') : null,
        date:    nowDone ? new Date().toISOString().split('T')[0] : null,
      };
    });
    const { error } = await supabase
      .from('onboarding_checklists')
      .update({ items: updated })
      .eq('id', checklist.id);
    if (!error) setChecklist(p => ({ ...p, items: updated }));
    setSaving(p => ({ ...p, [itemId]: false }));
  }

  async function updateNotes(itemId, notes) {
    if (!canEdit || !checklist) return;
    const updated = checklist.items.map(i => i.id === itemId ? { ...i, notes } : i);
    setChecklist(p => ({ ...p, items: updated }));
  }

  async function saveNotes(itemId, notes) {
    if (!checklist) return;
    const updated = checklist.items.map(i => i.id === itemId ? { ...i, notes } : i);
    await supabase.from('onboarding_checklists').update({ items: updated }).eq('id', checklist.id);
  }

  const totalItems = checklist?.items?.length || 0;
  const doneItems  = checklist?.items?.filter(i => i.done).length || 0;
  const pct        = totalItems > 0 ? Math.round(doneItems / totalItems * 100) : 0;

  const typeConf   = checklist ? (TYPE_CONFIG[checklist.type] || { label: checklist.type, color: C.navy, hasTimeline: false }) : null;
  const hasTimeline = typeConf?.hasTimeline;

  const grouped = checklist ? checklist.items.reduce((acc, item) => {
    if (!acc[item.area]) acc[item.area] = [];
    acc[item.area].push(item);
    return acc;
  }, {}) : {};

  const TIMELINE_ORDER = ['Day 1','Week 1','Week 2','Week 3','Week 4'];
  const groupedByTimeline = checklist ? checklist.items.reduce((acc, item) => {
    const key = item.timeline || 'Week 1';
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {}) : {};

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:600,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'}}
      onClick={e=>{ if(e.target===e.currentTarget) onClose(); }}>
      <div style={{background:C.white,borderRadius:'16px',width:'100%',maxWidth:'680px',maxHeight:'90vh',overflowY:'auto',boxShadow:'0 24px 64px rgba(0,0,0,0.22)',display:'flex',flexDirection:'column'}}>

        {/* Header */}
        <div style={{padding:'18px 24px',background:C.navy,borderRadius:'16px 16px 0 0',display:'flex',alignItems:'center',justifyContent:'space-between',position:'sticky',top:0,zIndex:1}}>
          <div>
            <div style={{fontWeight:700,fontSize:'15px',color:C.white}}>Onboarding Checklist</div>
            <div style={{fontSize:'12px',color:C.skyBlue,marginTop:'2px'}}>
              {member.name}
              {typeConf && (
                <span style={{marginLeft:'6px',padding:'1px 7px',borderRadius:'20px',background:'rgba(255,255,255,0.15)',fontSize:'11px',fontWeight:700,color:C.white}}>
                  {typeConf.label}
                </span>
              )}
            </div>
          </div>
          <button onClick={onClose} style={{background:'rgba(255,255,255,0.12)',border:'none',borderRadius:'8px',cursor:'pointer',color:C.white,padding:'6px',display:'flex'}}>
            <X size={18}/>
          </button>
        </div>

        <div style={{padding:'20px 24px',flex:1}}>

          {/* Loading */}
          {loading && <p style={{color:C.mid,fontSize:'13px'}}>Loading...</p>}

          {/* No checklist yet */}
          {!loading && !checklist && !pickType && (
            <div style={{textAlign:'center',padding:'32px 0'}}>
              <div style={{fontSize:'2rem',marginBottom:'12px'}}>📋</div>
              <p style={{fontWeight:700,fontSize:'15px',color:C.charcoal,margin:'0 0 6px'}}>No checklist started</p>
              <p style={{fontSize:'13px',color:C.mid,margin:'0 0 20px'}}>Start an onboarding checklist for {member.name}.</p>
              {canEdit && (
                <button onClick={()=>setPickType(true)}
                  style={{padding:'10px 24px',background:C.navy,color:C.white,border:'none',borderRadius:'9px',cursor:'pointer',fontWeight:600,fontSize:'13px'}}>
                  Start Checklist
                </button>
              )}
            </div>
          )}

          {/* Type picker */}
          {!loading && pickType && (
            <div>
              <p style={{fontWeight:700,fontSize:'14px',color:C.charcoal,margin:'0 0 14px'}}>Choose checklist type:</p>
              <div style={{display:'flex',gap:'10px',flexWrap:'wrap'}}>
                {Object.entries(TYPE_CONFIG).map(([type, conf]) => (
                  <button key={type} onClick={()=>startChecklist(type)} disabled={starting}
                    style={{flex:'1 1 140px',padding:'18px 14px',background:C.cream,border:`2px solid ${C.border}`,borderRadius:'12px',cursor:'pointer',fontSize:'14px',fontWeight:600,color:C.charcoal,display:'flex',flexDirection:'column',alignItems:'center',gap:'6px',transition:'all 0.15s'}}
                    onMouseEnter={e=>{e.currentTarget.style.borderColor=conf.color;e.currentTarget.style.background=C.white;}}
                    onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.background=C.cream;}}>
                    <span style={{fontSize:'1.8rem'}}>{conf.icon}</span>
                    {starting ? 'Creating...' : conf.label}
                  </button>
                ))}
              </div>
              <button onClick={()=>setPickType(false)}
                style={{marginTop:'14px',padding:'6px 14px',border:`1px solid ${C.border}`,borderRadius:'8px',background:C.white,cursor:'pointer',fontSize:'12px',color:C.mid}}>
                Cancel
              </button>
            </div>
          )}

          {/* Active checklist */}
          {!loading && checklist && (
            <>
              {/* Progress bar */}
              <div style={{marginBottom:'20px'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'6px'}}>
                  <span style={{fontSize:'12px',fontWeight:600,color:C.mid}}>Progress</span>
                  <span style={{fontSize:'13px',fontWeight:700,color:pct===100?C.green:C.charcoal}}>{doneItems}/{totalItems} complete · {pct}%</span>
                </div>
                <div style={{height:'8px',background:C.cream,borderRadius:'999px',overflow:'hidden',border:`1px solid ${C.border}`}}>
                  <div style={{height:'100%',width:`${pct}%`,background:pct===100?C.green:C.navy,borderRadius:'999px',transition:'width 0.4s'}}/>
                </div>
                {pct===100 && (
                  <div style={{marginTop:'8px',padding:'6px 12px',background:C.greenLight,borderRadius:'8px',fontSize:'12px',fontWeight:600,color:C.green,textAlign:'center'}}>
                    ✓ Checklist complete!
                  </div>
                )}
              </div>

              {/* View toggle — only for checklists that have timelines */}
              {hasTimeline && (
                <div style={{display:'flex',gap:'4px',marginBottom:'16px',background:C.cream,padding:'3px',borderRadius:'8px',width:'fit-content'}}>
                  {[['category','By Area'],['timeline','By Timeline']].map(([mode,label])=>(
                    <button key={mode} onClick={()=>setViewMode(mode)} style={{
                      padding:'5px 12px',borderRadius:'6px',border:'none',
                      background:viewMode===mode?C.white:'transparent',
                      color:viewMode===mode?C.charcoal:C.mid,
                      fontSize:'12px',fontWeight:viewMode===mode?700:400,
                      cursor:'pointer',transition:'all 0.15s',
                      boxShadow:viewMode===mode?'0 1px 3px rgba(0,0,0,0.1)':'none',
                    }}>{label}</button>
                  ))}
                </div>
              )}

              {/* Category view (always available, default for manager) */}
              {(!hasTimeline || viewMode==='category') && Object.entries(grouped).map(([area, items])=>(
                <div key={area} style={{marginBottom:'18px'}}>
                  <div style={{fontSize:'11px',fontWeight:700,color:C.mid,textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:'6px',paddingBottom:'4px',borderBottom:`1px solid ${C.border}`}}>
                    {area}
                  </div>
                  <div style={{display:'flex',flexDirection:'column',gap:'4px'}}>
                    {items.map(item=>(
                      <ChecklistRow key={item.id} item={item} canEdit={canEdit} saving={saving}
                        toggleItem={toggleItem} updateNotes={updateNotes} saveNotes={saveNotes}
                        showArea={false}
                      />
                    ))}
                  </div>
                </div>
              ))}

              {/* Timeline view (FOH/barista only) */}
              {hasTimeline && viewMode==='timeline' && TIMELINE_ORDER.filter(t=>groupedByTimeline[t]).map(timeline=>{
                const items = groupedByTimeline[timeline];
                const done  = items.filter(i=>i.done).length;
                return (
                  <div key={timeline} style={{marginBottom:'18px'}}>
                    <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'6px',paddingBottom:'4px',borderBottom:`1px solid ${C.border}`}}>
                      <span style={{fontSize:'12px',fontWeight:700,padding:'2px 8px',borderRadius:'999px',background:done===items.length?C.greenLight:timeline==='Day 1'?C.orangeLight:C.skyBlueLight,color:done===items.length?C.green:timeline==='Day 1'?C.amber:C.skyText}}>{timeline}</span>
                      <span style={{fontSize:'11px',color:C.mid}}>{done}/{items.length} done</span>
                      {done===items.length&&<span style={{fontSize:'11px',color:C.green,fontWeight:600}}>✓ complete</span>}
                    </div>
                    <div style={{display:'flex',flexDirection:'column',gap:'4px'}}>
                      {items.map(item=>(
                        <ChecklistRow key={item.id} item={item} canEdit={canEdit} saving={saving}
                          toggleItem={toggleItem} updateNotes={updateNotes} saveNotes={saveNotes}
                          showArea
                        />
                      ))}
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </div>
  );
}